<template>
  <div>
    <button type="button" class="icon-btn" title="Edit product" @click="showmodal">
      <feather type="edit-2" size="16"></feather>
    </button>
    <b-modal size="xl" :id="'EditProductModal' + ProductID" title="Edit product" @show="OnShowModal"
      @shown="initImageOrder" @hide="clear" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="container-fluid">
        <b-modal :ref="'ProductEditAlert' + ProductID" title="Admin" @ok="close()" ok-only>
          <p class="my-4">{{ message }}</p>
        </b-modal>
        <div class="row">
          <div class="col-lg-9">
            <div class="row product-adding">
              <div class="col-xl-4">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label for="validationtitle" class="col-form-label pt-0">Title <span>*</span></label>
                    <ValidationProvider name="Title" rules="required" v-slot="{ errors }">
                      <input class="form-control" id="validationtitle" type="text" v-model="form.title" required="" />
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label for="validationslug" class="col-form-label pt-0">Slug</label>
                  <input class="form-control" id="validationslug" type="text" v-model="form.slug" />
                </div>
              </div>
              <div class="col-xl-4">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label class="col-form-label pt-0">Category <span>*</span></label>
                    <ValidationProvider name="Category" rules="required" v-slot="{ errors }">
                      <b-form-select v-model="form.category" :options="getCategories()"></b-form-select>
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>
            <div class="row product-adding">
              <div class="col-xl-12">
                <label>Short description</label>
                <vue-editor v-model="form.description"></vue-editor><br />
              </div>
            </div>
            <div class="row product-adding">
              <div class="col-xl-4">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label for="validationprice" class="col-form-label pt-0">Price <span>*</span></label>
                    <ValidationProvider name="Price" rules="required" v-slot="{ errors }">
                      <input class="form-control" id="validationprice" type="number" v-model="form.price" required="" />
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label for="validationcompare" class="col-form-label pt-0">Compare at price</label>
                    <input class="form-control" id="validationcompare" type="text" v-model="form.compare_at_price" />
                  </div>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label for="validationcostprice" class="col-form-label pt-0">Cost price</label>
                    <input class="form-control" id="validationcostprice" type="number" v-model="form.cost_price" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row product-adding">
              <div class="col-xl-4">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label for="validationstock" class="col-form-label pt-0">Stock <span>*</span></label>
                    <ValidationProvider name="Stock" rules="required" v-slot="{ errors }">
                      <input class="form-control" id="validationstock" type="number" v-model="form.stock" required="" />
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div class="col-xl-8">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label for="validationaffiliatelink" class="col-form-label pt-0">Affiliate Link <span>* (If as
                        affiliate)</span></label>
                    <input class="form-control" id="validationaffiliatelink" type="text" v-model="form.affiliateLink"
                      required="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="product-adding">
              <b-tabs content-class="mt-3">
                <b-tab title="Upload image" active>
                  <div class="col-xl-12">
                    <label class="col-form-label pt-0">Images</label>
                    <vue-dropzone id="Images" :options="ImagesOptions" class="dropzone digits" ref="images"
                      :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess"
                      v-on:vdropzone-removed-file="fileRemoved" @vdropzone-complete="uploadComplete"
                      @vdropzone-sending="sending" @vdropzone-error="uploadError">
                    </vue-dropzone>
                    <!-- L'ordre des miniatures est l'ordre de form.images : c'est
                       lui qui donne FirstImage (image des collections) et l'ordre
                       de la galerie de la fiche produit. -->
                    <small class="image-order-hint">
                      Drag the thumbnails to change the order.
                      <span class="image-order-hint-main">The first image is the one displayed in the
                        collections.</span>
                    </small>
                    <br />
                  </div>
                </b-tab>
                <b-tab title="Images link">
                  <div class="col-xl-12">
                    <div class="digital-add needs-validation">
                      <div class="form-group">
                        <label for="image1" class="col-form-label pt-0">Link image1</label>
                        <input class="form-control" id="image1" type="text" v-model="form.image1" required="" />
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="digital-add needs-validation">
                      <div class="form-group">
                        <label for="image2" class="col-form-label pt-0">Link image2</label>
                        <input class="form-control" id="image2" type="text" v-model="form.image2" required="" />
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="digital-add needs-validation">
                      <div class="form-group">
                        <label for="image3" class="col-form-label pt-0">Link image3</label>
                        <input class="form-control" id="image3" type="text" v-model="form.image3" required="" />
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="digital-add needs-validation">
                      <div class="form-group">
                        <label for="image4" class="col-form-label pt-0">Link image4</label>
                        <input class="form-control" id="image4" type="text" v-model="form.image4" required="" />
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="solid" style="margin-top:28px">
              <div class="text-left">
                <b-form-checkbox switch size="s" v-model="form.status"> Active </b-form-checkbox>
              </div>
              <div class="text-left">
                <b-form-checkbox switch size="s" v-model="form.landing">Landing page</b-form-checkbox>
              </div>
              <div class="text-left">
                <b-form-checkbox switch size="s" v-model="form.affiliate">as affiliate</b-form-checkbox>
              </div>
            </div>
            <div class="solid" style="margin-top: 28px;">
              <h4 class="text-center">Offer</h4>
              <hr>
              <div class="text-left">
                <b-form-checkbox switch size="s" v-model="form.isOffer"> Deal of the week (home page) </b-form-checkbox>
              </div>
              <div class="form-group" v-if="form.isOffer">
                <label for="offerendsat" class="col-form-label pt-0">Offer end date </label>
                <input class="form-control" id="offerendsat" type="date" v-model="form.offerEndsAt" />
                <small class="text-muted">After this date the offer no longer appears on the home page.</small>
              </div>
            </div>
            <div class="solid" style="margin-top: 28px;">
              <h4 class="text-center">Home page</h4>
              <hr>
              <div class="text-left">
                <b-form-checkbox switch size="s" v-model="form.isTopPick"> Top pick of the week </b-form-checkbox>
              </div>
              <div class="text-left">
                <b-form-checkbox switch size="s" v-model="form.isNewArrival"> New arrival </b-form-checkbox>
              </div>
            </div>
            <div class="solid" style="position:sticky; top:40px; margin-top: 28px;">
              <h4 class="text-center">Style</h4>
              <hr>
              <form id="colorForm">
                <label for="textColor">Text color:</label>
                <input id="textColor" type="color" v-model="form.textColor" />

                <label for="backgroundColor">Background color:</label>
                <input id="backgroundColor" type="color" v-model="form.backgroundColor" />

                <label for="opacity">Opacity:</label>
                <input id="opacity" type="range" min="0" max="1" step="0.1" v-model="form.opacity">
              </form>
              <hr>
              <label for="textColor">Call To Action:</label>
              <input class="form-control" id="calltoactionn" type="text" v-model="form.callToAction"/>
            </div>
          </div>
        </div>
        <hr>
        <div class="row product-adding">
          <div class="col-xl-12">
            <label class="col-form-label pt-0">Sections</label>
            <b-container class="solid">
              <div class="col-xl-12 text-right">
                <button type="button" class="btn btn-default" @click="Addsection">
                  Add Section
                </button>
              </div>
              <div v-for="(item, index) in form.article" :key="index">
                <hr>
                <div class="row">
                  <div class="col-lg-9">
                    <div class="product-adding">

                      <div class="col-xl-12">
                        <div class="row" style="justify-content: space-around;">
                          <div class="">
                            <h2>{{ index + 1 }}</h2>
                          </div>
                          <div class="col-xl-10">
                            <div class="digital-add needs-validation">
                              <div class="form-group">
                                <label for="validationtitle" class="col-form-label pt-0">Title</label>
                                <input class="form-control" id="validationtitle" type="text" v-model="item.title"
                                  required="" />
                              </div>

                            </div>
                          </div>
                          <div class="col-xl-1" style="text-align: end;">
                            <feather type="trash" stroke="#4050F6" stroke-width="" size="22px" fill="#4050F6"
                              @click="Delsection(index)"></feather>
                          </div>
                        </div>
                      </div>
                      <div class="product-adding">
                        <b-tabs content-class="mt-3">
                          <b-tab title="Upload image" active>
                            <div class="col-xl-12">
                              <label class="col-form-label pt-0">Images</label>
                              <vue-dropzone id='drop' :options="ImagesOptionsSection[index]" class="dropzone digits"
                                ref="dropzone" :index=index :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess"
                                v-on:vdropzone-removed-file="fileRemovedImageSection($event, index)"
                                @vdropzone-complete="(file, response) => uploadCompleteImageSection(file, index, response)"
                                @vdropzone-sending="sending" @vdropzone-error="uploadError">
                              </vue-dropzone>
                              <br />
                            </div>
                          </b-tab>
                          <b-tab title="Images link">
                            <div class="col-xl-12">
                              <div class="digital-add needs-validation">
                                <div class="form-group">
                                  <label for="image1" class="col-form-label pt-0">Link image1</label>
                                  <input class="form-control" id="image1" type="text" v-model="form.article[index].image1"
                                    required="" />
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-12">
                              <div class="digital-add needs-validation">
                                <div class="form-group">
                                  <label for="image2" class="col-form-label pt-0">Link image2</label>
                                  <input class="form-control" id="image2" type="text" v-model="form.article[index].image2"
                                    required="" />
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-12">
                              <div class="digital-add needs-validation">
                                <div class="form-group">
                                  <label for="image3" class="col-form-label pt-0">Link image3</label>
                                  <input class="form-control" id="image3" type="text" v-model="form.article[index].image3"
                                    required="" />
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-12">
                              <div class="digital-add needs-validation">
                                <div class="form-group">
                                  <label for="image4" class="col-form-label pt-0">Link image4</label>
                                  <input class="form-control" id="image4" type="text" v-model="form.article[index].image4"
                                    required="" />
                                </div>
                              </div>
                            </div>
                          </b-tab>
                        </b-tabs>
                      </div>
                      <div class="col-xl-12">
                        <label>Description</label>
                        <vue-editor v-model="item.section"></vue-editor><br />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="solid" style="position:sticky; top:40px; margin-top: 28px;">
                      <h4 class="text-center">Style</h4>
                      <hr>
                      <form id="colorForm">
                        <label for="textColor">Text color:</label>
                        <input id="textColor" type="color" v-model="item.textColor" />

                        <label for="backgroundColor">Background color:</label>
                        <input id="backgroundColor" type="color" v-model="item.backgroundColor" />

                        <label for="opacity">Opacity:</label>
                        <input id="opacity" type="range" min="0" max="1" step="0.1" v-model="item.opacity">
                      </form>
                      <hr>
                      <label for="textColor">Call To Action:</label>
                      <input class="form-control" id="calltoactionn" type="text" v-model="item.callToAction"
                        required="" />
                    </div>
                  </div>
                </div>
              </div>
            </b-container>
          </div>
        </div>
        <hr>
        <div class="row product-adding">
          <div class="col-xl-12">
            <label class="col-form-label pt-0">Variants</label>
            <b-container class="solid">
              <div class="col-xl-12 text-right">
                <button type="button" class="btn btn-default" @click="AddVariants" :disabled="form.variants.length >= 2">
                  Add Variant
                </button>
              </div>
              <div v-for="(item, index) in form.variants" :key="index">
                <hr>
                <b-row>
                  <b-col>
                    <div class="form-group">
                      <label for="validationoption" class="col-form-label pt-0">Option </label>
                      <input class="form-control" id="validationoption" type="text" v-model="item.option" required="" />
                    </div>
                  </b-col>
                  <b-col>
                    <div class="form-group">
                      <label for="validationvalue" class="col-form-label pt-0">Value </label>
                      <b-form-tags input-id="validationvalue" v-model="item.value"
                        placeholder="Enter new value"></b-form-tags>
                    </div>
                  </b-col>
                  <b-col class="text-left pt-4">
                    <feather type="trash" stroke="#4050F6" stroke-width="" size="22px" fill="#4050F6"
                      @click="DelVariants(index)"></feather>
                  </b-col>
                </b-row>
              </div>
              <div class="col-xl-12 text-right" v-if="form.variants.length > 0">
                <hr>
                <button type="button" class="btn btn-primary" @click="generateVariants"
                  :disabled="form.variants.length == 0">Generate</button>
              </div>
              <div v-for="(item, index) in form.TablePriceVariants" :key="index">
                <hr>
                <b-row>
                  <b-col class="text-center pt-4">
                    <div class="form-group">
                      <label for="vcolor" class="col-form-label pt-0">{{ item.value }} </label>
                    </div>
                  </b-col>
                  <b-col>
                    <div class="form-group">
                      <label for="vprice" class="col-form-label pt-0">Price </label>
                      <input class="form-control" id="vprice" type="number" v-model="item.price" required="" />
                    </div>
                  </b-col>
                  <b-col>
                    <div class="form-group">
                      <label for="vcompare" class="col-form-label pt-0">Compare at price </label>
                      <input class="form-control" id="vcompare" type="number" v-model="item.compare_at_price"
                        required="" />
                    </div>
                  </b-col>
                  <b-col>
                    <div class="form-group">
                      <label for="vlink" class="col-form-label pt-0">Link </label>
                      <input class="form-control" id="vcompare" type="text" v-model="item.link" required="" />
                    </div>
                  </b-col>
                  <b-col class="text-center pt-4">
                    <b-form-radio v-model="item.default" name="some-radios" value="true">Default variant
                    </b-form-radio>
                  </b-col>
                </b-row>
              </div>
            </b-container>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-lg-9">
            <div class="row product-adding">
              <div class="col-xl-12">
                <label class="col-form-label pt-0">Reviews</label>
                <b-container class="solid">
                  <div class="col-xl-12 text-right">
                    <button type="button" class="btn btn-default" @click="AddReviews">
                      Add Review
                    </button>
                  </div>
                  <div v-for="(item, index) in form.reviews" :key="index">
                    <div class="pt-2 pb-2">
                      <hr>
                    </div>
                    <div class="row product-adding">
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="vname" class="col-form-label pt-0">Name </label>
                          <input class="form-control" id="vname" type="text" v-model="item.name" required="" />
                        </div>
                      </div>
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="vstate" class="col-form-label pt-0">State </label>
                          <input class="form-control" id="vstate" type="text" v-model="item.state" required="" />
                        </div>
                      </div>
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="vrating" class="col-form-label pt-0">Rate </label>
                          <input class="form-control" id="vrating" type="number" v-model="item.rating" required="" />
                        </div>
                      </div>
                      <div class="col-xl-3 pt-4">
                        <feather type="trash" stroke="#4050F6" stroke-width="" size="22px" fill="#4050F6"
                          @click="DelReview(index)"></feather>
                      </div>
                    </div>
                    <div class="row product-adding" style="padding-left: 20px;padding-right:20px;">
                      <label for="vreview" class="col-form-label pt-0">Review </label>
                      <b-form-textarea id="vreview" v-model="item.review" placeholder="Enter something..." rows="3"
                        max-rows="6"></b-form-textarea>
                    </div>
                  </div>
                </b-container>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="solid" style="margin-top:28px">
              <div class="text-left">
                <b-form-checkbox switch size="s" v-model="form.addingreviews"> Allow adding reviews </b-form-checkbox>
              </div>
            </div>
            <div class="solid" style="position:sticky; top:40px; margin-top: 28px;">
              <h4 class="text-center">Style</h4>
              <hr>
              <form id="colorForm">
                <label for="textColor">Text color:</label>
                <input id="textColor" type="color" v-model="form.ReviewTextColor" />
                <label for="backgroundColor">Background color:</label>
                <input id="backgroundColor" type="color" v-model="form.ReviewBackgroundColor" />
                <label for="opacity">Opacity:</label>
                <input id="opacity" type="range" min="0" max="1" step="0.1" v-model="form.ReviewOpacity">
              </form>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-lg-9">
            <div class="row product-adding">
              <div class="col-xl-12">
                <label class="col-form-label pt-0">Contact From</label>
                <b-container class="solid">
                  <div class="row product-adding">
                    <div class="col-xl-12">
                      <div class="form-group">
                        <label for="vtitle" class="col-form-label pt-0">Title </label>
                        <input class="form-control" id="vtitle" type="text" v-model="form.contact.title" required="" />
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <div class="form-group">
                        <b-form-checkbox switch size="s" v-model="form.contact.firstname"> First name </b-form-checkbox>
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <div class="form-group">
                        <b-form-checkbox switch size="s" v-model="form.contact.lastname"> Last name </b-form-checkbox>
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <div class="form-group">
                        <b-form-checkbox switch size="s" v-model="form.contact.address"> Address </b-form-checkbox>
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <div class="form-group">
                        <b-form-checkbox switch size="s" v-model="form.contact.city"> City </b-form-checkbox>
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <div class="form-group">
                        <b-form-checkbox switch size="s" v-model="form.contact.postcode"> Post code </b-form-checkbox>
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <div class="form-group">
                        <b-form-checkbox switch size="s" v-model="form.contact.country"> Country </b-form-checkbox>
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <div class="form-group">
                        <b-form-checkbox switch size="s" v-model="form.contact.phone"> Phone </b-form-checkbox>
                      </div>
                    </div>
                  </div>
                </b-container>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="solid" style="position:sticky; top:40px; margin-top: 28px;">
              <h4 class="text-center">Style</h4>
              <hr>
              <form id="colorForm">
                <label for="textColor">Text color:</label>
                <input id="textColor" type="color" v-model="form.contact.TextColor"/>
                <label for="backgroundColor">Background color:</label>
                <input id="backgroundColor" type="color" v-model="form.contact.BackgroundColor"/>
                <label for="borderColor">Border color:</label>
                <input id="borderColor" type="color" v-model="form.contact.BorderColor"/>
                <label for="opacity">Opacity:</label>
                <input id="opacity" type="range" min="0" max="1" step="0.1" v-model="form.contact.opacity"/>
              </form>
              <hr>
              <label for="textColor">Call To Action:</label>
              <input class="form-control" id="calltoactionn" type="text" v-model="form.contact.callToAction"/>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-lg-12">
            <div class="row product-adding">
              <div class="col-xl-12">
                <label class="col-form-label pt-0">Elements</label>
                <b-container class="solid">
                  <div class="row product-adding">
                    <div class="col-xl-3">
                      <div class="form-group">
                        <b-form-checkbox switch size="s" v-model="form.ShowRating"> Show Rating </b-form-checkbox>
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <div class="form-group">
                        <b-form-checkbox switch size="s" v-model="form.ShowSimilarProduct"> Show Similar Product </b-form-checkbox>
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <div class="form-group">
                        <b-form-checkbox switch size="s" v-model="form.ShowIndicator"> Show Indicator </b-form-checkbox>
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <div class="form-group">
                        <b-form-checkbox switch size="s" v-model="form.ShowSubscriber"> Show Subscriber </b-form-checkbox>
                      </div>
                    </div>
                  </div>
                </b-container>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="row product-adding">
          <div class="col-xl-12">
            <div class="digital-add needs-validation">
              <div class="form-group">
                <label for="validationmetatitle" class="col-form-label pt-0">Meta title </label>
                <input class="form-control" id="validationmetatitle" type="text" v-model="form.metaTitle" />
              </div>
            </div>
          </div>
        </div>
        <div class="row product-adding">
          <div class="col-xl-12">
            <div class="digital-add needs-validation">
              <div class="form-group">
                <label for="validationmetadescription" class="col-form-label pt-0">Meta description</label>
                <input class="form-control" id="validationmetadescription" type="text" v-model="form.metaDescription" />
              </div>
            </div>
          </div>
        </div>
        <div class="row product-adding">
          <div class="col-xl-12">
            <div class="digital-add needs-validation">
              <div class="form-group">
                <label for="validationmetakeyword" class="col-form-label pt-0">Meta Keywords </label>
                <input class="form-control" id="validationmetakeyword" type="text" v-model="form.metaKeywords" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-12 pb-3">
          <div class="form-group mb-0">
            <div class="product-buttons text-right">
              <button type="button" class="btn btn-light mr-2" @click="back">
                Cancel
              </button>
              <button type="button" class="btn btn-primary" @click="save">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import firebase from '@/utils/firestore-shim';
import { uploadUrl, uploadHeaders, reportUploadError } from './../../utils/imageUpload';
import { VueEditor } from "vue2-editor";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import sliderModalAdd from "./../stores/sliders/sliderModalAdd.vue";
import sliderModalEdit from "./../stores/sliders/sliderModalEdit.vue";
import VueAutoDropzone from 'vue-auto-dropzone';
import { uuid } from "vue-uuid";
import { enableImageOrder } from './../../utils/imageOrder';

// Squelette du formulaire d'édition. Le template lit directement
// « form.variants.length » : si form est réduit à {}, le rendu du composant
// lève une TypeError et le bouton comme la modale disparaissent du DOM (la
// modale ne peut alors plus s'ouvrir). Cette fabrique est partagée par data(),
// clear() et hide(), comme le fait déjà ProductModalAdd.vue.
const emptyForm = () => ({
  title: '',
  slug: '',
  description: '',
  price: 0,
  compare_at_price: 0,
  cost_price: 0,
  images: [],
  article: [],
  status: true,
  vendors: [],
  contact: {},
  sku: '',
  stock: 5,
  weight: '',
  category: '',
  meta_title: '',
  meta_description: '',
  variants: [],
  TablePriceVariants: [],
  reviews: [],
  FirstImage: null,
  affiliateLink: ''
});

export default {
  components: { sliderModalAdd, sliderModalEdit, VueAutoDropzone, VueEditor },
  props: ["SiteID", "ProductID", "Data", "categories", "host"],
  data() {
    return {
      form: emptyForm(),
      images: [],
      ImagesOptions: {
        url: uploadUrl,
        headers: uploadHeaders(),
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        maxFiles: 10,
        params: [],
        maxfilesexceeded: function (file) {

        },
        accept: function (file, done) {
          done();
        },
        init: function () {
          this.removeAllFiles();
          let images = this.options.params;
          images.forEach((e) => {
            let f = {
              size: '12300',
              name: e.filename,
              dataURL: e.src,
            };
            this.emit("addedfile", f);
            this.emit("thumbnail", f, f.dataURL);
            this.emit("complete", f);
            this.files.push(f);
          });
        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple: true,
        maxThumbnailFilesize: 20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
      },
      ImagesOptionsSection: [{
        url: uploadUrl,
        headers: uploadHeaders(),
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        maxFiles: 10,
        params: [],
        maxfilesexceeded: function (file) {

        },
        accept: function (file, done) {
          done();
        },
        init: function () {
          this.removeAllFiles();
          let images = this.options.params;
          images.forEach((e) => {
            let f = {
              size: '12300',
              name: e.filename,
              dataURL: e.src,
            };
            this.emit("addedfile", f);
            this.emit("thumbnail", f, f.dataURL);
            this.emit("complete", f);
            this.files.push(f);
          });
        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple: true,
        maxThumbnailFilesize: 20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
      }],
      message: "",
      error: 0,
      editor: ClassicEditor,
      imagePreview: null
    };
  },
  mounted() {

  },
  beforeDestroy() {
    // Libère les écouteurs et l'observateur posés sur la zone Images.
    if (this.imageOrder) {
      this.imageOrder.destroy();
      this.imageOrder = null;
    }
  },
  methods: {
    async save() {
      if ((this.form.title == "") || (this.form.price == "") || (this.form.stock == "")) {
        this.message = "Please complete all required fields!";
        this.error = 1;
        this.$refs['ProductEditAlert' + this.ProductID].show();
        return false;
      } else {
        this.error = 0;
      }
      if ((this.form.affiliate) && (this.form.affiliateLink == "")) {
        this.message = "Affiliate link field required!";
        this.error = 1;
        this.$refs['ProductAddAlert' + this.id].show();
        return false;
      } else {
        this.error = 0;
      }
      this.form.FirstImage = this.form.images.length > 0 ? this.form.images[0].src : this.form.image1 != '' ? this.form.image1 : ''; let ref = firebase.firestore().collection('Sites').doc(this.SiteID).collection('Products').doc(this.ProductID);
      // « selected » est l'état de la coche de suppression en masse dans la
      // liste, pas un champ produit : il ne doit pas être persisté.
      const payload = Object.assign({}, this.form);
      delete payload.selected;
      await ref.set(payload)
        .then(() => {
          this.message = "Document successfully written!";
          this.error = 0;
          this.$refs['ProductEditAlert' + this.ProductID].show()
        })
        .catch((error) => {
          this.message = "Error writing document: " + error;
          this.error = 1;
          this.$refs['ProductEditAlert' + this.ProductID].show()
        });
      this.$emit('ok', this.form);
    },
    async getProduct() {
      let listData = {};
      var ProductRef = firebase.firestore().collection("Sites").doc(this.SiteID).collection("Products").doc(this.ProductID);
      await ProductRef.get().then((e) => {
        let element = {};
        element = e.data();
        element.id = e.id;
        listData.push(element);
      });
      return listData;
    },
    close() {
      if (this.error == 0) this.$bvModal.hide('EditProductModal' + this.ProductID);
    },
    back() {
      this.$bvModal.hide('EditProductModal' + this.ProductID);
    },
    showmodal() {
      this.$bvModal.show('EditProductModal' + this.ProductID);
    },
    OnShowModal() {
      let x = this.Data;
      this.form = x;
      // Produits importés avant certaines fonctions : les tableaux attendus par
      // le template (form.variants.length, v-for sur article/reviews...) peuvent
      // manquer. Sans normalisation, le rendu lève une TypeError et la modale
      // ne s'affiche pas.
      ['images', 'article', 'vendors', 'variants', 'TablePriceVariants', 'reviews'].forEach((k) => {
        if (!Array.isArray(this.form[k])) this.$set(this.form, k, []);
      });
      if (this.form.contact === undefined || this.form.contact === null) this.$set(this.form, 'contact', {});
      // Champs de l'offre absents des produits créés avant cette fonction :
      // sans $set, la coche ne serait pas réactive (Vue 2 n'observe pas
      // l'ajout d'une propriété après coup).
      if (this.form.isOffer === undefined) this.$set(this.form, 'isOffer', false);
      if (this.form.offerEndsAt === undefined) this.$set(this.form, 'offerEndsAt', '');
      if (this.form.isTopPick === undefined) this.$set(this.form, 'isTopPick', false);
      if (this.form.isNewArrival === undefined) this.$set(this.form, 'isNewArrival', false);
      this.ImagesOptions.params = x.images;
      this.images = x.images;
      for (var i = 0; i <= x.article.length - 1; i++) {
        if (i > 0) {
          this.ImagesOptionsSection.push({
            url: uploadUrl,
            headers: uploadHeaders(),
            thumbnailWidth: 150,
            thumbnailHeight: 150,
            maxFiles: 10,
            params: [],
            maxfilesexceeded: function (file) {

            },
            accept: function (file, done) {
              done();
            },
            init: function () {
              this.removeAllFiles();
              let images = this.options.params;
              if (images) {
                images.forEach((e) => {
                  let f = {
                    size: '12300',
                    name: e.filename,
                    dataURL: e.src,
                  };
                  this.emit("addedfile", f);
                  this.emit("thumbnail", f, f.dataURL);
                  this.emit("complete", f);
                  this.files.push(f);
                });
              }
            },
            maxFilesize: 100,
            addRemoveLinks: true,
            uploadMultiple: true,
            maxThumbnailFilesize: 20,
            dictDefaultMessage:
              "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
          });
        }
        this.ImagesOptionsSection[i].params.push(x.article[i].images[0]);
      }
    },
    // Zone Images : le glisser-déposer des miniatures fixe l'ordre de
    // form.images. Initialisé sur « shown » car le contenu d'un b-modal non
    // lazy n'est monté qu'à l'ouverture : this.$refs.images n'existe pas avant.
    initImageOrder() {
      this.$nextTick(() => {
        const dz = this.$refs.images;
        const container = dz ? dz.$el : null;
        if (!container) return;
        this.imageOrder = enableImageOrder(container, {
          getFiles: () => (dz.dropzone ? dz.dropzone.files : []),
          onOrder: (names) => this.applyImageOrder(names)
        });
      });
    },
    // Réécrit form.images dans l'ordre des miniatures. Les entrées sans
    // miniature (upload en cours) restent en fin de liste. FirstImage suit
    // immédiatement la première image : c'est elle que lisent les collections
    // vitrine (product-grid.init.js, RelatedProducts.ejs, accueil) et c'est la
    // première slide de la galerie de la fiche produit.
    applyImageOrder(names) {
      const pool = (this.form.images || []).slice();
      const ordered = [];
      (names || []).forEach((name) => {
        const index = pool.findIndex((e) => e && e.filename === name);
        if (index >= 0) ordered.push(pool.splice(index, 1)[0]);
      });
      pool.forEach((e) => ordered.push(e));
      this.form.images = ordered;
      if (ordered.length > 0 && ordered[0].src) {
        this.$set(this.form, 'FirstImage', ordered[0].src);
      }
    },
    clear() {
      // Le contenu du b-modal est démonté à la fermeture : la zone Images et
      // ses écouteurs disparaissent avec lui.
      if (this.imageOrder) {
        this.imageOrder.destroy();
        this.imageOrder = null;
      }
      // Réinitialisation complète (jamais {}) : voir emptyForm().
      this.form = emptyForm();
      this.ImagesOptionsSection = [{
        url: uploadUrl,
        headers: uploadHeaders(),
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        maxFiles: 10,
        params: [],
        maxfilesexceeded: function (file) {

        },
        accept: function (file, done) {
          done();
        },
        init: function () {
          this.removeAllFiles();
          let images = this.options.params;
          images.forEach((e) => {
            let f = {
              size: '12300',
              name: e.filename,
              dataURL: e.src,
            };
            this.emit("addedfile", f);
            this.emit("thumbnail", f, f.dataURL);
            this.emit("complete", f);
            this.files.push(f);
          });
        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple: true,
        maxThumbnailFilesize: 20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
      }]
    },
    uploadComplete(file, response) {
      // L'API renvoie directement { url: '/uploads/...' } : l'image est
      // déjà stockée sur le serveur, plus besoin de renvoyer l'aperçu.
      try {
        var data = typeof response === 'string' ? JSON.parse(response) : (response || {});
        this.form.images.push({
          'image_id': this.$uuid.v1(),
          'src': data.url,
          'alt': "",
          'variant_id': [],
          'filename': file.name
        });
      } catch (e) {
        reportUploadError(this, e.message);
      }
    },
    uploadError(file, message) {
      reportUploadError(this, message);
    },
    sending(file, xhr, formData) {
      // Juste avant l'envoi : indique à l'API le dossier de stockage
      // (l'option dropzone « params » est déjà utilisée pour l'affichage
      // des images existantes, on passe par cet événement à la place).
      formData.append('folder', 'sites/' + this.host + '/products');
    },
    uploadCompleteImageSection(file, index, response) {
      try {
        var data = typeof response === 'string' ? JSON.parse(response) : (response || {});
        this.form.article[index].images.push({
          'src': data.url,
          'filename': this.$uuid.v1()
        });
      } catch (e) {
        reportUploadError(this, e.message);
      }
    },

    fileRemovedImageSection(file, index) {
      if (index < this.$refs.dropzone.length - 1) {
        this.form.article[index].images = this.form.article[index].images.filter((e) => e.filename != file.name);
      }
    },
    uploadSuccess(file) {

    },
    fileRemoved(file) {
      this.form.images = this.form.images.filter((e) => e.filename != file.name);
    },
    getCategories() {
      if (!this.categories) return [];
      let categories = []
      this.categories.forEach((e) => {
        categories.push({ value: e.category, text: e.category });
      });
      return categories;
    },
    hide() {
      this.form = emptyForm();
    },
    Addsection() {
      this.form.article.push(
        {
          title: '',
          images: [],
          section: '',
          callToAction: '',
          textColor: '#000000',
          backgroundColor: '#ffffff',
          opacity: 0.5,
          image1: '',
          image2: '',
          image3: '',
          image4: ''
        }
      );
      this.ImagesOptionsSection.push({
        url: uploadUrl,
        headers: uploadHeaders(),
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        maxFiles: 10,
        params: [],
        maxfilesexceeded: function (file) {

        },
        accept: function (file, done) {
          done();
        },
        init: function () {
          this.removeAllFiles();
          let images = this.options.params;
          if (images) {
            images.forEach((e) => {
              let f = {
                size: '12300',
                name: e.filename,
                dataURL: e.src,
              };
              this.emit("addedfile", f);
              this.emit("thumbnail", f, f.dataURL);
              this.emit("complete", f);
              this.files.push(f);
            });
          }
        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple: true,
        maxThumbnailFilesize: 20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
      });
    },
    Delsection(index) {
      if (index != 0) {
        this.form.article.splice(index, 1);
        this.ImagesOptionsSection.splice(index, 1)
      }
    },
    AddVariants() {
      this.form.variants.push(
        {
          option: '',
          value: []
        }
      );
    },
    AddReviews() {
      this.form.reviews.push(
        {
          name: '',
          state: '',
          rating: 5,
          review: '',
          ReviewBackgroundColor: '#ffffff',
          ReviewTextColor: '#000000',
          ReviewOpacity:'0.5'
        }
      );
    },
    DelVariants(index) {
      this.form.variants.splice(index, 1);
      this.generateVariants();
    },
    DelReview(index) {
      this.form.reviews.splice(index, 1);
    },
    generateVariants() {
      var result = [];
      if (this.form.variants.length == 1) {
        for (let i = 0; i < this.form.variants[0].value.length; i++) {
          result.push({
            "option": this.form.variants[0].option,
            "value": this.form.variants[0].value[i],
            "price": this.form.price,
            "compare_at_price": this.form.compare_at_price,
            "default": "false"
          })
        }
      }
      if (this.form.variants.length == 2) {
        for (let i = 0; i < this.form.variants[0].value.length; i++) {
          for (let j = 0; j < this.form.variants[1].value.length; j++) {
            result.push({
              "option": [this.form.variants[0].option, this.form.variants[1].option],
              "value": [this.form.variants[0].value[i], this.form.variants[1].value[j]],
              "price": this.form.price,
              "compare_at_price": this.form.compare_at_price,
              "default": "false"
            })
          }
        }
      }
      this.form.TablePriceVariants = result;
    }
  }
};
</script>
<style>
.dropzone .dz-preview .dz-image img {
  display: block;
  width: 150px;
  height: 150px;
}

.solid {
  border: 2px dashed #ff8084;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;
}
</style>